<template>
  <div :class="['v-input', inputSize, invalidInput]">
    <label v-if="label" class="v-input-label" :for="id">
      {{ label }}
    </label>
    <textarea
      class="v-input-control"
      :rows="rows"
      :name="name"
      :type="type"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', event.target.value)"
      v-mask="mask ? mask : null"
    />
    <div
      v-if="error && typeof message == 'string'"
      class="v-input-invalid-feedback"
    >
      <span>{{ message }}</span>
    </div>
    <div
      v-if="error && Array.isArray(message)"
      class="v-input-invalid-feedback"
    >
      <span v-for="msg in message" :key="msg">
        {{ msg }}
      </span>
    </div>
  </div>
</template>

<script>
const sizes = Object.freeze({
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl"
});

export default {
  name: "BaseTextarea",
  props: {
    label: {
      type: String,
      default: ""
    },
    rows: {
      type: [String, Number],
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      required: true,
      default: "text"
    },
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      validator: value => Object.values(sizes).includes(value),
      default: sizes.MD
    },
    error: {
      type: Boolean
    },
    message: {
      type: [String, Array],
      default: ""
    },
    mask: {
      type: [String, Array],
      default: ""
    }
  },
  computed: {
    inputSize() {
      return `v-input-${this.size}`;
    },
    invalidInput() {
      return this.error && "v-input-invalid";
    }
  }
};
</script>
